import React from "react"
import { Button, FormControl, Spinner } from "react-bootstrap"
import { FaKey } from "react-icons/fa"
import Util from "../util/Util";
import LoginAPI from "../api/LoginAPI";
import withRouter from "../util/WithRouter";
import { Link } from "react-router-dom";

class ChangePasswordPage extends React.Component {

  constructor(props) {
    super(props)
    this.state = { password: "", confirmPassword: "", isLoading: false }
  }

  onChangePassword = event => this.setState({...this.state, password: event.target.value})
  onChangeConfirmPassword = event => this.setState({...this.state, confirmPassword: event.target.value})

  onSubmitClick = () => {
    if(!this.state.confirmPassword || !this.state.password) {
      Util.showNotification("Invalid fields",  "All fields are required", "danger")
      return
    }

    if(this.state.confirmPassword !== this.state.password) {
      Util.showNotification("Invalid password", "Password do not match", "danger")
      return
    }
    // Make server request 
    this.setState({...this.state, isLoading: true})
    const token = this.props.params.token
    LoginAPI.changePassword(token, this.state.confirmPassword, this.onResponse, this.failure)
    this.setState({...this.state, isLoading: false})
  }

  onResponse = res => {
    Util.showNotification("Success",  res.message || "", "success")
    this.props.navigate("/", { replace:" true" })
  }

  failure = res => {
    Util.showNotification("Failure",  res.message || "" , "danger")
    this.props.navigate("/", { replace:" true" })
  }

  render() {
    return (
      <div className="container-fluid d-flex align-items-center justify-content-center min-vh-100 p-3"
        style={{backgroundImage: "url(/images/admin-2.png)"}}
      >
        <div className="reset-card">
          <div className="logo-section">
              <div className="d-inline-flex align-items-center justify-content-center text-white fw-semibold fs-6 mb-3 logo-placeholder">
                <img className=" client_logo_login_logout"
                  src={process.env.PUBLIC_URL + "/images/logo.png"}
                  alt="Logo" 
                />
              </div>
              <h2 className="reset-title">Change Password</h2>
              <p className="reset-subtitle">Set a strong new password to keep your account secure.</p>
          </div>
          
          <form id="reset-form">
            <div className="form-group">
              <div className="input-group">
                <span className="input-icon d-flex align-items-center justify-content-center">
                  <FaKey />
              </span>
              <FormControl
                type="password"
                autoComplete="off"
                autoFocus="on"
                placeholder="Password"
                className="form-control py-2"
                value={this.state.password}
                onChange={this.onChangePassword}
                required
              />
              </div>
            </div>

            <div className="form-group mt-1">
              <div className="input-group">
                <span className="input-icon d-flex align-items-center justify-content-center">
                  <FaKey  />
                </span>
                <FormControl
                  type="password"
                  autoComplete="off"
                  autoFocus="on"
                  placeholder="Confirm Password"
                  className="form-control py-2"
                  value={this.state.confirmPassword}
                  onChange={this.onChangeConfirmPassword}
                  required
                  />
              </div>
            </div>
              
              <Button
              className="mt-3  btn-md w-100 submit-btn"
              onClick={this.onSubmitClick}
              color="#098dcb"
              disabled={this.state.isLoading}
              >
              {this.state.isLoading &&  
                <Spinner animation="border" role="loading" size="sm" className="me-2">
                  <span  className="visually-hidden">Loading...</span>
                </Spinner>
              }
              Submit
            </Button>
          </form>
          
          <div className="text-center mt-3">
            <Link to={"/"} nonce="">
              Back to login
            </Link>
          </div>
        </div>
      </div>
      )
  }
}

export default withRouter(ChangePasswordPage)